import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { goTo } from '../../actions';
import styled from 'styled-components';
import theme from '../../theme';
import { MenuItem, MenuDivider, Button } from "@blueprintjs/core";
import EmailSettings from '../../containers/EmailSettings';
import LanguageSettings from '../../containers/LanguageSettings';
import LogoutMenuItem from '../../containers/LogoutMenuItem';
import LogoutButton from '../../containers/LogoutButton';
import BillingSettings from '../../containers/BillingSettings';
import {
  APP_URL,
  APP_NAME,
  CONTACT_EMAIL,
  APP_YEAR,
  PRIVACY_POLICY_PAGE,
  HOME_PAGE
} from '../../constants';
import { formatPxToNumber } from '../../utils';

const SETTINGS = 'Settings';
const BILLING = 'Billing';
const ABOUT = 'About';

const Container = styled.div`
  -webkit-app-region: drag;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: center;
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch; /* For smooth scrolling in iOS */
  flex: 1;
  background: ${theme.darkGray4};
`;

const SectionContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch; /* For smooth scrolling in iOS */
  padding: 30px;
  background: ${theme.lightGray5};
`;


function Settings() {
  return (
    <SectionContainer>
      <h3>{SETTINGS}</h3>
      <div className="horizontal-divider"/>
      <h4>Email</h4>
      <EmailSettings/>
      <div className="horizontal-divider"/>
      <h4>Languages</h4>
      <LanguageSettings/>
    </SectionContainer>
  )
}

function Billing() {
  return (
    <SectionContainer>
      <h3>{BILLING}</h3>
      <BillingSettings/>
    </SectionContainer>
  )
}

function About() {
  return (
    <SectionContainer>
      <h3>{ABOUT}</h3>
      <div>
        <br/>
        <h5>Contact</h5>
        <p>{CONTACT_EMAIL}</p>
        <br/>
        <h5>Privacy Policy</h5>
        <p>
          <a
            href={`${APP_URL}${PRIVACY_POLICY_PAGE}`}
            target="_blank"
          >
            {APP_URL}{PRIVACY_POLICY_PAGE}
          </a>
        </p>
        <br/>
        <p>Copyright © {APP_YEAR} {APP_NAME}. All Rights Reserved.</p>
      </div>
    </SectionContainer>
  )
}

const menuSections = {};
menuSections[SETTINGS.toLowerCase()] = <Settings/>;
menuSections[BILLING.toLowerCase()] = <Billing/>;
menuSections[ABOUT.toLowerCase()] = <About/>;

class PrivateSettings extends React.Component {

  state = {
    width: null,
    section: 'settings'
  };

  componentDidMount() {
    if (this.ref) {
      const width = this.ref.clientWidth;
      this.setState({width});
    }
  }

  isWideEnough() {
    return this.state.width >= formatPxToNumber(theme.verySmallScreenCutoff);
  }

  render() {

    const isWideEnough = this.isWideEnough();

    const menu = isWideEnough ? (
        <div className="pt-menu">
          <MenuItem
            icon="arrow-left"
            text="Back"
            onClick={() => this.props.goTo(HOME_PAGE)}
          />
          <MenuDivider/>
          <MenuItem
            icon="cog" text={SETTINGS}
            onClick={() => this.setState({section: SETTINGS.toLowerCase()})}
          />
          <MenuItem
            icon="credit-card" text={BILLING}
            onClick={() => this.setState({section: BILLING.toLowerCase()})}
          />
          <MenuItem
            icon="info-sign" text={ABOUT}
            onClick={() => this.setState({section: ABOUT.toLowerCase()})}
          />
          <MenuDivider/>
          <LogoutMenuItem />
        </div>
      ) : (
        <div className="flex-center-column">
          <Button
            className="pt-minimal"
            icon="arrow-left"
            onClick={() => this.props.goTo(HOME_PAGE)}
          />
          <Button
            className="pt-minimal"
            icon="cog"
            onClick={() => this.setState({section: SETTINGS.toLowerCase()})}
          />
          <Button
            className="pt-minimal"
            icon="credit-card"
            onClick={() => this.setState({section: BILLING.toLowerCase()})}
          />
          <Button
            className="pt-minimal"
            icon="info-sign"
            onClick={() => this.setState({section: ABOUT.toLowerCase()})}
          />
          <LogoutButton/>
        </div>
      );


    return (
      <Container innerRef={ref => this.ref = ref}>
        <div className="pt-dark">
          <div className="horizontal-divider"/>
          {menu}
        </div>
        {menuSections[this.state.section]}
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({goTo}, dispatch)
}

PrivateSettings = connect(
  null,
  mapDispatchToProps
)(PrivateSettings);

export default PrivateSettings;



// WEBPACK FOOTER //
// ./src/components/PrivateSettings/index.js